module.exports = __webpack_public_path__ + "static/img/220.c68611ec.png";